import { render } from "./Credentinal.vue?vue&type=template&id=3159d0f0&scoped=true"
import script from "./Credentinal.vue?vue&type=script&lang=js"
export * from "./Credentinal.vue?vue&type=script&lang=js"

import "./Credentinal.vue?vue&type=style&index=0&id=3159d0f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3159d0f0"]])

export default __exports__